export const isRedirectAllowed = (sessionId: string): boolean =>
    window.europa?.sessionId === sessionId;
